import React from 'react';
import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { SettingsPageLayoutStyles } from './settings-page-layout.styles';

type Props = {
  children: React.ReactNode;
} & CommonHTMLAttributes;

export const SettingsPageLayout = ({ children, ...rest }: Props) => (
  <div {...rest} className={cx(SettingsPageLayoutStyles.settingsPageLayoutDivStyle1, rest.className)}>
    {children}
  </div>
);
